// 仅可使用 util/utils_cover 不可使用util/utils
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// import LanguageDetector from 'i18next-browser-languagedetector';
import { getkey } from "./utils_cover";
import { codeToLocale, localeToCode, browserLangToLocale } from "./langConfig";
import { LANGUAGE_PACKS } from "./lang_packs";
import { ensureRemoteLanguagePacks, subscribeRemoteLanguagePacks } from "./remote_lang_pack";

// 语言包登记表见 ./lang_packs（映射唯一来源）；此处 re-export，外部引用路径不变
export { LANGUAGE_PACKS };

const I18N_RESOURCES = Object.keys(LANGUAGE_PACKS).reduce((acc, code) => {
  acc[code] = { translation: LANGUAGE_PACKS[code].data };
  return acc;
}, {});
export default (fallbackLng = 'en') => {
    const getBrowserLang = () => {
        const browserLang = navigator.language || navigator.browserLanguage;
        return browserLang.toLowerCase(); // 返回小写格式，如 "zh-cn"
    };
    const browserLang = getBrowserLang();
    // 优先级：URL 显式参数 > sessionStorage（上次选择的语言）> page 默认 fallback > 浏览器语言
    const urlLangKey = getkey('fallbackLng'); // 仅来自 URL query，不存在则 null
    const sessionLang = sessionStorage.getItem('lang');
    const upCookie = (urlLangKey && codeToLocale(urlLangKey))
        || sessionLang
        || codeToLocale(fallbackLng)
        || browserLangToLocale(browserLang);
    fallbackLng = localeToCode(upCookie);

    sessionStorage.setItem('lang', upCookie)
   
    i18n
        // 检测用户当前使用的语言
        // 文档: https://github.com/i18next/i18next-browser-languageDetector
        // .use(LanguageDetector)
        // 注入 react-i18next 实例
        .use(initReactI18next)
        // 初始化 i18next
        // 配置参数的文档: https://www.i18next.com/overview/configuration-options
        .init({
            fallbackLng: fallbackLng,
            lng: fallbackLng,
            interpolation: {
                escapeValue: false,
            },
            nsSeparator: '---', // 将默认的 : 改为其他符号
            keySeparator: '---',
            debug: false,
            resources: I18N_RESOURCES,
            react: {
                useSuspense: false, // 禁用 Suspense 以避免加载状态
                wait: true // 等待翻译加载完成
            }
        });

    // 远程语言包：本地包已同步注册进 i18n 兜底，这里异步拉远程包，
    // 到位后按「远程优先」覆盖进 i18n，并触发一次重渲染让文案刷新。
    let remoteRefreshTimer = null;
    subscribeRemoteLanguagePacks((code, pack) => {
        i18n.addResourceBundle(code, "translation", pack, true, true);
        if (remoteRefreshTimer) clearTimeout(remoteRefreshTimer);
        remoteRefreshTimer = setTimeout(() => {
            remoteRefreshTimer = null;
            i18n.changeLanguage(i18n.language);
        }, 0);
    });
    ensureRemoteLanguagePacks();

    return i18n;
}

